import {default as _AuthService} from "./authService"
import {default as _ApiService} from "./apiService";
import {default as _FileService} from "./fileService";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs"

let cachedFingerprint = null

// Utility to get or cache the fingerprint
const getFingerprint = async () => {
    if (cachedFingerprint) return cachedFingerprint
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    cachedFingerprint = result.visitorId
    return cachedFingerprint
}

export const http = axios.create({
    withCredentials: true,
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: {
        "Content-type": "application/json"
    },
    validateStatus: status=> status >= 200 && status < 300
});

http.interceptors.request.use(
    async config => {
        config.headers["X-Client-Fingerprint"] = await getFingerprint()
        return config
    },
    error => Promise.reject(error)
)

export const AuthService = new _AuthService();
export const ApiService = new _ApiService();
export const FileService = new _FileService();

export default {
    AuthService,
    ApiService,
    FileService
}
